import React, { FC } from "react";
import { CardContainer } from "./styled";

export interface CardProps {
  elevation?: number;
  background?: string;
  borderRadius?: number;
  justifyContent?: string;
  padding?: number;
}

export const Card: FC<CardProps> = ({
  elevation = 0,
  background,
  borderRadius = 8,
  padding = 24,
  children,
}) => (
  <CardContainer
    elevation={elevation}
    background={background}
    borderRadius={borderRadius}
    padding={padding}
  >
    {children}
  </CardContainer>
);
